import apiAction from "../ajax/service"
import { setInvoiceConfigs } from "../features/workspaceSlice"
import { generateUUID, safeParse } from "../helpers/helper"



const loadConfigs = async (dispatch) => {
    const data = await apiAction("invoicebuilder",{},"getConfigs")
    if(dispatch){
        dispatch(setInvoiceConfigs(data))
    }
    return data
}


const loadConfig = async (id) => {
    const data = await apiAction("invoicebuilder",{id , filters:{id}},"getConfig")
    return data
}

const createNewConfig = async (config='{}') => {
    let tmpConfig = safeParse(config)
    const data = await apiAction("invoicebuilder",{ configName : "Template "+ generateUUID() , config : config , currency:tmpConfig.currency},"add")
    return data
}
const deleteConfig = async (id) =>{

    const data = await apiAction("invoicebuilder",{ id},"delete")
    return data

}

const saveConfig = async (id,configName , config ,currency) => {

    const data = await apiAction("invoicebuilder",{id, configName , config, currency },"update")
    return data
}

const downloadSample = async (previewData,currency) => {
    const data = await apiAction("invoicebuilder",{previewData,currency},"generate")
    return data
}
const generateInvoice = async (agreementId , invoiceId , regenerate = false ,workspaceId = sessionStorage.getItem('selectedWorkspace')) => {
    const data = await apiAction("invoicebuilder",{agreementId , regenerate , invoiceId , workspaceId},"generate")

}
const setAsDefault = async (id,workspaceId = sessionStorage.getItem('selectedWorkspace')) => {
    if (!workspaceId) return
    const data = await apiAction("workspace",{filters:{workspaceId:workspaceId ,hasUnique:true },defaultInvoiceConfig:id , },"set_default_invoice")
    return data
}
export {setAsDefault, generateInvoice , deleteConfig,loadConfig ,createNewConfig,saveConfig, loadConfigs,downloadSample}
